import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { ShieldCheck } from "lucide-react";

export function AdminBanner() {
  const { isAdmin, logout } = useSite();
  if (!isAdmin) return null;
  return (
    <div className="on-dark bg-[#1B3530] text-[#F5AE3D]" data-testid="admin-banner">
      <div className="of-container flex min-h-[44px] flex-wrap items-center justify-between gap-x-4 gap-y-1 py-1 text-sm">
        <p className="inline-flex items-center gap-2 font-semibold" data-testid="admin-banner-text">
          <ShieldCheck className="h-4 w-4" aria-hidden /> Logged in as Admin
        </p>
        <div className="flex items-center gap-1">
          <Link to="/admin/inbox" className="inline-flex min-h-[44px] items-center rounded-full px-3 font-semibold text-white underline-offset-4 hover:underline"
            data-testid="admin-banner-inbox-link">Inbox</Link>
          <Link to="/admin/images" className="inline-flex min-h-[44px] items-center rounded-full px-3 font-semibold text-white underline-offset-4 hover:underline"
            data-testid="admin-banner-images-link">Images</Link>
          <Link to="/admin/settings" className="inline-flex min-h-[44px] items-center rounded-full px-3 font-semibold text-white underline-offset-4 hover:underline"
            data-testid="admin-banner-settings-link">Admin settings</Link>
          <button type="button" onClick={logout} className="inline-flex min-h-[44px] items-center rounded-full px-3 font-semibold text-white underline-offset-4 hover:underline"
            data-testid="admin-banner-logout-button">Log out</button>
        </div>
      </div>
    </div>
  );
}

export function AdminPanel({ title, children, testId }) {
  const { isAdmin } = useSite();
  if (!isAdmin) return null;
  return (
    <div className="mt-6 rounded-3xl border-2 border-dashed border-[#24453D]/60 bg-white/90 p-5 text-left" data-testid={testId}>
      <p className="mb-3 text-xs font-bold uppercase tracking-[0.16em] text-[var(--pg-ink)]">Admin edit · only you can see this</p>
      {title && <p className="mb-4 font-display text-lg">{title}</p>}
      {children}
    </div>
  );
}
